/**Map para correlacionar url con logos de instituciones */
export const mapLogo = new Map<string, string>();
mapLogo.set( "localhost:4200", "/assets/logos-inst/cmir.png"); 
mapLogo.set("espaciomo.ar","/assets/logos-inst/MO.png");
mapLogo.set("ilanding.red-i.com.ar","/assets/logos-inst/cmir.png");
mapLogo.set("idemo.red-i.com.ar",'/assets/logos-inst/cmir.png');
mapLogo.set("asocespaniola.com.ar","/assets/logos-inst/asocespanola.png")
mapLogo.set("amesalud.ar","/assets/logos-inst/amesalud.png")
mapLogo.set("idev.red-i.kozaca.com.ar",'/assets/logos-inst/cmir.png');
mapLogo.set("romamedicinaestetica.com.ar",'/assets/logos-inst/roma.png');
mapLogo.set("www.romamedicinaestetica.com.ar",'/assets/logos-inst/roma.png');